module.exports = __webpack_public_path__ + "img/logout.c9080957.svg";